import { hydrateRoot } from "react-dom/client";
import { App, pageFromPath } from "./App";

hydrateRoot(document.getElementById("root") as HTMLElement, <App page={pageFromPath(window.location.pathname)} />);
